import React, { useState, useEffect } from "react";
import { Modal, Button, Form, Alert, Row, Col } from "@themesberg/react-bootstrap";
import axios from "axios";
import { BASE_URL } from "../../constants";

const AddShelterModal = ({ show, onHide, newShelter, setNewShelter, handleAddShelter }) => {
  const [users, setUsers] = useState([]); // State to store users
  const [loading, setLoading] = useState(true); 
  const [successMessage, setSuccessMessage] = useState("");

  useEffect(() => {
    const fetchUsers = async () => {
      try {
        const response = await axios.get(`${BASE_URL}/users`);
        // Filter users where isAdmin is true
        const admins = response.data.filter(user => user.isAdmin
        );
        setUsers(admins);
      } catch (error) {
        console.error("Error fetching users:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchUsers();
  }, []);


  const handleSubmit = async () => {
    try {
      // Send data to the API
      await axios.post(`${BASE_URL}/shelters`, newShelter);
      setSuccessMessage("Shelter added successfully!");
      setNewShelter({
        name: "",
        address: { street: "", city: "", postalCode: "", country: "" },
       
      
        contactInfo: { phone: "", email: "" },
         
        costPerOccupant: "",
        stateCoverage: ""
      });
      setTimeout(() => {
        onHide(); 
        setSuccessMessage("");
      }, 3000); 
    } catch (error) {
      console.error("Error adding shelter:", error);
    }
  };
  
  const handleInputChange = (e) => {
    const { name, value } = e.target;

    if (name.startsWith("contactInfo.")) {
      const field = name.split(".")[1];
      setNewShelter(prev => ({
        ...prev,
        contactInfo: { ...prev.contactInfo, [field]: value }
      }));
    } else if (name.startsWith("address.")) {
      const field = name.split(".")[1];
      setNewShelter(prev => ({
        ...prev,
        address: { ...prev.address, [field]: value }
      }));
    } else {
      setNewShelter(prev => ({ ...prev, [name]: value }));
    }
  };

  return (
    <Modal show={show} onHide={onHide} centered size="lg">
      <Modal.Header closeButton>
        <Modal.Title>Add Shelter</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form>

          {/* Shelter Name and Street */}
          <Row>
            <Col md={6}>
              <Form.Group>
                <Form.Label>Shelter Name</Form.Label>
                <Form.Control
                  type="text"
                  name="name"
                  placeholder="Enter shelter name"
                  value={newShelter.name}
                  onChange={handleInputChange}
                />
              </Form.Group>
            </Col>
            <Col md={6}>
              <Form.Group>
                <Form.Label>Street</Form.Label>
                <Form.Control
                  type="text"
                  name="address.street"
                  placeholder="Enter street"
                  value={newShelter.address?.street || ""}
                  onChange={handleInputChange}
                />
              </Form.Group>
            </Col>
          </Row>

          {/* City and Postal Code */}
          <Row>
            <Col md={6}>
              <Form.Group>
                <Form.Label>City</Form.Label>
                <Form.Control
                  type="text"
                  name="address.city"
                  placeholder="Enter city"
                  value={newShelter.address?.city || ""}
                  onChange={handleInputChange}
                />
              </Form.Group>
            </Col>
            <Col md={6}>
              <Form.Group>
                <Form.Label>Postal Code</Form.Label>
                <Form.Control
                  type="text"
                  name="address.postalCode"
                  placeholder="Enter postal code"
                  value={newShelter.address?.postalCode || ""}
                  onChange={handleInputChange}
                />
              </Form.Group>
            </Col>
          </Row>

          {/* Country and Capacity */}
          <Row>
            <Col md={6}>
              <Form.Group>
                <Form.Label>Country</Form.Label>
                <Form.Control
                  type="text"
                  name="address.country"
                  placeholder="Enter country"
                  value={newShelter.address?.country || ""}
                  onChange={handleInputChange}
                />
              </Form.Group>
            </Col>
            <Col md={6}>
              <Form.Group>
                <Form.Label>Capacity</Form.Label>
                <Form.Control
                  type="number"
                  name="capacity"
                  placeholder="Enter capacity"
                  value={newShelter.capacity}
                  onChange={handleInputChange}
                />
              </Form.Group>
            </Col>
          </Row>

          {/* Number of Rooms and Phone */}
          <Row>
            <Col md={6}>
              <Form.Group>
                <Form.Label>Number of Rooms</Form.Label>
                <Form.Control
                  type="number"
                  name="numberRooms"
                  placeholder="Enter number of rooms"
                  value={newShelter.numberRooms}
                  onChange={handleInputChange}
                />
              </Form.Group>
            </Col>
            <Col md={6}>
              <Form.Group>
                <Form.Label>Phone</Form.Label>
                <Form.Control
                  type="text"
                  name="contactInfo.phone"
                  placeholder="Enter phone"
                  value={newShelter.contactInfo?.phone || ""}
                  onChange={handleInputChange}
                />
              </Form.Group>
            </Col>
          </Row>

          {/* Email and Cost per Occupant */}
          <Row>
            <Col md={6}>
              <Form.Group>
                <Form.Label>Email</Form.Label>
                <Form.Control
                  type="email"
                  name="contactInfo.email"
                  placeholder="Enter email"
                  value={newShelter.contactInfo?.email || ""}
                  onChange={handleInputChange}
                />
              </Form.Group>
            </Col>
            <Col md={6}>
              <Form.Group>
                <Form.Label>Cost Per Occupant</Form.Label>
                <Form.Control
                  type="number"
                  name="costPerOccupant"
                  placeholder="Enter cost per occupant"
                  value={newShelter.costPerOccupant}
                  onChange={handleInputChange}
                />
              </Form.Group>
            </Col>
          </Row>

          {/* State Coverage and Responsible Person */}
          <Row>
            <Col md={6}>
              <Form.Group>
                <Form.Label>State Coverage</Form.Label>
                <Form.Control
                  type="number"
                  name="stateCoverage"
                  placeholder="Enter state coverage"
                  value={newShelter.stateCoverage}
                  onChange={handleInputChange}
                />
              </Form.Group>
            </Col>
            <Col md={6}>
              <Form.Group>
                <Form.Label>Responsible Person</Form.Label>
                <Form.Control
                  as="select"
                  name="responsiblePerson"
                  value={newShelter.responsiblePerson}
                  onChange={handleInputChange}
                >
                  <option value="">Select a responsible person</option>
                  {loading ? (
                    <option>Loading users...</option>
                  ) : (
                    users.map(user => (
                      <option key={user._id} value={user._id}>
                        {`${user.firstName} ${user.lastName}`}
                      </option>
                    ))
                  )}
                </Form.Control>
              </Form.Group>
            </Col>
          </Row>

          {successMessage && (
            <Alert variant="success" className="mt-3">{successMessage}</Alert>
          )}

        </Form>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={onHide}>Close</Button>
        <Button variant="primary" onClick={handleSubmit}>Add Shelter</Button>
      </Modal.Footer>
    </Modal>
  );
};

export default AddShelterModal;